import {Component, Input} from '@angular/core';
import {RegisterCompanyStepBase} from '../register-company-step.base';

@Component({
    selector: 'app-register-company-payment',
    templateUrl: './payment-step.component.html',
    styleUrls: ['../../register-company.component.scss']
})
export class RegisterCompanyPaymentStepComponent extends RegisterCompanyStepBase {

    @Input() planId = '';
    @Input() billingPeriod: 'monthly' | 'yearly' = 'monthly';

    get checkoutEmail(): string {
        return (this.company?.legalEmail || this.company?.companyEmail || '').trim();
    }

    onPaymentCompleted(): void {
        this.nextStep();
    }
}
